export default __webpack_public_path__ + "static/media/card-insta-suvinil1.cc1ade86.jpg";